class MFRAccentsParallax {
  constructor( index, element ) {
      this.index = index;
      this.$element = $( element );

      this.init();
  }

  init() {
    this.initGSAPfunction()
  }

  initGSAPfunction() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(e, {
      yPercent: `${$( e ).data( "accent-graphic-parallax-speed" ) * 50}`,
      ease: "none"
    },{
      yPercent: `-${$( e ).data( "accent-graphic-parallax-speed" ) * 50}`,
      ease: "none",
      scrollTrigger: {
        trigger: $( e ),
        scrub: true
      }
    });
  }
}